import React from "react";
import "./footer.css";
const Footer = () => {
  return <footer>Made by CraZyCr7</footer>;
};

export default Footer;